export default {
    "en": {
      "submitButton": "Submit",
      "orderTrackingPlaceHolder": "#12345",
      "productDetailsLink": "View Details",
      "collectionDetailsLink": "View Collection",
      "alwaysActive": "Online",
      "textPlaceholder": "Type a message...",
      "typing": "typing",
      "disclaimer": "By continuing, you understand and agree to our terms.",
      "addToCartText": "Add to Cart"
    },
    "en-alt": {
      "submitButton": "Submit",
      "orderTrackingPlaceHolder": "#12345",
      "productDetailsLink": "View Details",
      "collectionDetailsLink": "View Collection",
      "alwaysActive": "Online",
      "textPlaceholder": "Ask anything...",
      "typing": "typing",
      "disclaimer": "By continuing, you understand and agree to our terms.",
      "addToCartText": "Add to Cart"
    },
    "es": {
      "submitButton": "Enviar",
      "orderTrackingPlaceHolder": "Número de pedido",
      "productDetailsLink": "Ver detalles",
      "collectionDetailsLink": "Ver colección",
      "alwaysActive": "En línea",
      "textPlaceholder": "Escribe un mensaje...",
      "typing": "escribiendo",
      "disclaimer": "Al continuar, entiendes y aceptas nuestros términos.",
      "addToCartText": "Añadir al carrito"
    },
    "zh": {
      "submitButton": "提交",
      "orderTrackingPlaceHolder": "订单号",
      "productDetailsLink": "查看详情",
      "collectionDetailsLink": "查看收藏",
      "alwaysActive": "在线",
      "textPlaceholder": "输入消息...",
      "typing": "输入中",
      "disclaimer": "继续使用即表示您理解并同意我们的条款。",
      "addToCartText": "添加到购物车"
    },
    "hi": {
      "submitButton": "जमा करें",
      "orderTrackingPlaceHolder": "आदेश संख्या",
      "productDetailsLink": "विवरण देखें",
      "collectionDetailsLink": "संग्रह देखें",
      "alwaysActive": "ऑनलाइन",
      "textPlaceholder": "संदेश टाइप करें...",
      "typing": "टाइप कर रहा है",
      "disclaimer": "जारी रखने से आप हमारी शर्तों को समझते हैं और सहमत हैं।",
      "addToCartText": "जोड़ें टो कार्ट"
    },
    "ar": {
      "submitButton": "إرسال",
      "orderTrackingPlaceHolder": "رقم الطلب",
      "productDetailsLink": "عرض التفاصيل",
      "collectionDetailsLink": "عرض المجموعة",
      "alwaysActive": "متصل",
      "textPlaceholder": "اكتب رسالة...",
      "typing": "يكتب",
      "disclaimer": "بالمتابعة، فإنك تفهم وتوافق على شروطنا.",
      "addToCartText": "إضافة إلى السلة"
    },
    "fr": {
      "submitButton": "Soumettre",
      "orderTrackingPlaceHolder": "Numéro de commande",
      "productDetailsLink": "Voir les détails",
      "collectionDetailsLink": "Voir la collection",
      "alwaysActive": "En ligne",
      "textPlaceholder": "Tapez un message...",
      "typing": "tape",
      "disclaimer": "En continuant, vous comprenez et acceptez nos termes.",
      "addToCartText": "Ajouter au panier"
    },
    "bn": {
      "submitButton": "জমা দিন",
      "orderTrackingPlaceHolder": "অর্ডার নম্বর",
      "productDetailsLink": "বিস্তারিত দেখুন",
      "collectionDetailsLink": "সংগ্রহ দেখুন",
      "alwaysActive": "অনলাইন",
      "textPlaceholder": "একটি বার্তা টাইপ করুন...",
      "typing": "টাইপ করছে",
      "disclaimer": "যতটা এগিয়ে চলুন, আপনি আমাদের শর্তাবলী বুঝতে এবং সম্মত হচ্ছেন।",
      "addToCartText": "জমা করুন কার্ট"
    },
    "ru": {
      "submitButton": "Отправить",
      "orderTrackingPlaceHolder": "Номер заказа",
      "productDetailsLink": "Посмотреть детали",
      "collectionDetailsLink": "Посмотреть коллекцию",
      "alwaysActive": "В сети",
      "textPlaceholder": "Введите сообщение...",
      "typing": "печатает",
      "disclaimer": "Продолжая, вы понимаете и соглашаетесь с нашими условиями.",
      "addToCartText": "Добавить в корзину"
    },
    "pt": {
      "submitButton": "Enviar",
      "orderTrackingPlaceHolder": "Número do pedido",
      "productDetailsLink": "Ver detalhes",
      "collectionDetailsLink": "Ver coleção",
      "alwaysActive": "Online",
      "textPlaceholder": "Digite uma mensagem...",
      "typing": "digitando",
      "disclaimer": "Ao continuar, você entende e concorda com nossos termos.",
      "addToCartText": "Adicionar ao carrinho"
    },
    "ja": {
      "submitButton": "送信",
      "orderTrackingPlaceHolder": "注文番号",
      "productDetailsLink": "詳細を見る",
      "collectionDetailsLink": "コレクションを見る",
      "alwaysActive": "オンライン",
      "textPlaceholder": "メッセージを入力...",
      "typing": "入力中",
      "disclaimer": "続行することで、あなたは私たちの規約に同意したことになります。",
      "addToCartText": "カートに追加"
    },
    "de": {
      "submitButton": "Absenden",
      "orderTrackingPlaceHolder": "Bestellnummer",
      "productDetailsLink": "Details ansehen",
      "collectionDetailsLink": "Kollektion ansehen",
      "alwaysActive": "Online",
      "textPlaceholder": "Nachricht eingeben...",
      "typing": "tippt",
      "disclaimer": "Durch die Fortsetzung erklären Sie, dass Sie unsere Bedingungen verstehen und akzeptieren.",
      "addToCartText": "Zum Warenkorb hinzufügen"
    },
    "ko": {
      "submitButton": "제출",
      "orderTrackingPlaceHolder": "주문 번호",
      "productDetailsLink": "상세보기",
      "collectionDetailsLink": "컬렉션 보기",
      "alwaysActive": "온라인",
      "textPlaceholder": "메시지를 입력하세요...",
      "typing": "입력 중",
      "disclaimer": "계속 진행함으로써 귀하는 우리의 약관을 이해하고 동의하는 것입니다.",
      "addToCartText": "장바구니에 추가"
    },
    "it": {
      "submitButton": "Invia",
      "orderTrackingPlaceHolder": "Numero d'ordine",
      "productDetailsLink": "Vedi dettagli",
      "collectionDetailsLink": "Vedi collezione",
      "alwaysActive": "Online",
      "textPlaceholder": "Scrivi un messaggio...",
      "typing": "sta scrivendo",
      "disclaimer": "Continuando, comprendi e accetti i nostri termini.",
      "addToCartText": "Aggiungi al carrello"
    },
    "pl": {
      "submitButton": "Wyślij",
      "orderTrackingPlaceHolder": "Numer zamówienia",
      "productDetailsLink": "Zobacz szczegóły",
      "collectionDetailsLink": "Zobacz kolekcję",
      "alwaysActive": "Online",
      "textPlaceholder": "Wpisz wiadomość...",
      "typing": "pisze",
      "disclaimer": "Kontynuując, rozumiesz i zgadzasz się z naszymi warunkami.",
      "addToCartText": "Dodaj do koszyka"
    },
    "tr": {
      "submitButton": "Gönder",
      "orderTrackingPlaceHolder": "Sipariş numarası",
      "productDetailsLink": "Detayları gör",
      "collectionDetailsLink": "Koleksiyonu gör",
      "alwaysActive": "Çevrimiçi",
      "textPlaceholder": "Bir mesaj yazın...",
      "typing": "yazıyor",
      "disclaimer": "Devam ederek şartlarımızı anladığınızı ve kabul ettiğinizi kabul edersiniz.",
      "addToCartText": "Sepete Ekle"
    },
    "uk": {
      "submitButton": "Відправити",
      "orderTrackingPlaceHolder": "Номер замовлення",
      "productDetailsLink": "Переглянути деталі",
      "collectionDetailsLink": "Переглянути колекцію",
      "alwaysActive": "Онлайн",
      "textPlaceholder": "Введіть повідомлення...",
      "typing": "пишемо",
      "disclaimer": "Продовжуючи, ви розумієте та погоджуєтесь з нашими умовами.",
      "addToCartText": "Додати до кошика"
    },
    "fa": {
      "submitButton": "ارسال",
      "orderTrackingPlaceHolder": "شماره سفارش",
      "productDetailsLink": "مشاهده جزئیات",
      "collectionDetailsLink": "مشاهده مجموعه",
      "alwaysActive": "آنلاین",
      "textPlaceholder": "پیامی تایپ کنید...",
      "typing": "در حال تایپ",
      "disclaimer": "با ادامه دادن، شما شرایط ما را می‌فهمید و با آن موافقید.",
      "addToCartText": "افزودن به سبد خرید"
    },
    "ms": {
      "submitButton": "Hantar",
      "orderTrackingPlaceHolder": "Nombor pesanan",
      "productDetailsLink": "Lihat butiran",
      "collectionDetailsLink": "Lihat koleksi",
      "alwaysActive": "Dalam talian",
      "textPlaceholder": "Taip mesej...",
      "typing": "mengetik",
      "disclaimer": "Dengan meneruskan, anda memahami dan bersetuju dengan syarat kami.",
      "addToCartText": "Tambahkan ke keranjang"
    },
    "vi": {
      "submitButton": "Gửi",
      "orderTrackingPlaceHolder": "Số đơn hàng",
      "productDetailsLink": "Xem chi tiết",
      "collectionDetailsLink": "Xem bộ sưu tập",
      "alwaysActive": "Trực tuyến",
      "textPlaceholder": "Gõ tin nhắn...",
      "typing": "đang gõ",
      "disclaimer": "Khi tiếp tục, bạn hiểu và đồng ý với các điều khoản của chúng tôi.",
      "addToCartText": "Thêm vào giỏ hàng"
    },
    "th": {
      "submitButton": "ส่ง",
      "orderTrackingPlaceHolder": "หมายเลขคำสั่งซื้อ",
      "productDetailsLink": "ดูรายละเอียด",
      "collectionDetailsLink": "ดูคอลเล็กชัน",
      "alwaysActive": "ออนไลน์",
      "textPlaceholder": "พิมพ์ข้อความ...",
      "typing": "กำลังพิมพ์",
      "disclaimer": "โดยการดำเนินการต่อไป คุณเข้าใจและยอมรับข้อกำหนดของเรา",
      "addToCartText": "เพิ่มไปยังตะกร้า"
    },
    "ro": {
      "submitButton": "Trimite",
      "orderTrackingPlaceHolder": "Numărul comenzii",
      "productDetailsLink": "Vezi detalii",
      "collectionDetailsLink": "Vezi colecția",
      "alwaysActive": "Online",
      "textPlaceholder": "Scrie un mesaj...",
      "typing": "scrie",
      "disclaimer": "Continuând, înțelegeți și sunteți de acord cu termenii noștri.",
      "addToCartText": "Adaugă în coș"
    },
    "hu": {
      "submitButton": "Beküldés",
      "orderTrackingPlaceHolder": "Rendelési szám",
      "productDetailsLink": "Részletek megtekintése",
      "collectionDetailsLink": "Gyűjtemény megtekintése",
      "alwaysActive": "Online",
      "textPlaceholder": "Írjon üzenetet...",
      "typing": "ír",
      "disclaimer": "A folytatással Ön elfogadja és megérti a feltételeinket.",
      "addToCartText": "Hozzáadás a kosárhoz"
    },
    "cs": {
      "submitButton": "Odeslat",
      "orderTrackingPlaceHolder": "Číslo objednávky",
      "productDetailsLink": "Zobrazit detaily",
      "collectionDetailsLink": "Zobrazit kolekci",
      "alwaysActive": "Online",
      "textPlaceholder": "Napište zprávu...",
      "typing": "píše",
      "disclaimer": "Pokračováním souhlasíte a rozumíte našim podmínkám.",
      "addToCartText": "Přidat do košíku"
    },
    "nl": {
      "submitButton": "Verzenden",
      "orderTrackingPlaceHolder": "Bestelnummer",
      "productDetailsLink": "Bekijk details",
      "collectionDetailsLink": "Bekijk collectie",
      "alwaysActive": "Online",
      "textPlaceholder": "Typ een bericht...",
      "typing": "aan het typen",
      "disclaimer": "Door door te gaan, begrijpt en accepteert u onze voorwaarden.",
      "addToCartText": "Toevoegen aan winkelwagen"
    },
    "sv": {
      "submitButton": "Skicka",
      "orderTrackingPlaceHolder": "Ordernummer",
      "productDetailsLink": "Visa detaljer",
      "collectionDetailsLink": "Visa samling",
      "alwaysActive": "Online",
      "textPlaceholder": "Skriv ett meddelande...",
      "typing": "skriver",
      "disclaimer": "Genom att fortsätta accepterar du våra villkor.",
      "addToCartText": "Lägg till i kundvagn"
    },
    "id": {
      "submitButton": "Kirim",
      "orderTrackingPlaceHolder": "Nomor pesanan",
      "productDetailsLink": "Lihat detail",
      "collectionDetailsLink": "Lihat koleksi",
      "alwaysActive": "Online",
      "textPlaceholder": "Ketik pesan...",
      "typing": "sedang mengetik",
      "disclaimer": "Dengan melanjutkan, Anda memahami dan setuju dengan syarat kami.",
      "addToCartText": "Tambahkan ke keranjang"
    },
    "da": {
      "submitButton": "Send",
      "orderTrackingPlaceHolder": "Ordrenummer",
      "productDetailsLink": "Se produktet",
      "collectionDetailsLink": "Se kolleksjonen",
      "alwaysActive": "Online",
      "textPlaceholder": "Skriv en melding...",
      "typing": "skriver",
      "disclaimer": "Ved at fortsætte accepterer du vores vilkår.",
      "addToCartText": "Tilføj til kurv"
    },
    "no": {
      "submitButton": "Send",
      "orderTrackingPlaceHolder": "Bestillingsnummer",
      "productDetailsLink": "Se produktet",
      "collectionDetailsLink": "Se samling",
      "alwaysActive": "Pålogget",
      "textPlaceholder": "Skriv en melding...",
      "typing": "skriver",
      "disclaimer": "Ved å fortsette godtar du våre vilkår.",
      "addToCartText": "Tilføj til kurv"
    },
    "el": {
      "submitButton": "Υποβολή",
      "orderTrackingPlaceHolder": "Αριθμός παραγγελίας",
      "productDetailsLink": "Δείτε λεπτομέρειες",
      "collectionDetailsLink": "Δείτε τη συλλογή",
      "alwaysActive": "Συνδεδεμένος",
      "textPlaceholder": "Πληκτρολογήστε ένα μήνυμα...",
      "typing": "πληκτρολογεί",
      "disclaimer": "Συνεχίζοντας, κατανοείτε και αποδέχεστε τους όρους μας.",
      "addToCartText": "Προσθήκη στο καλάθι"
    },
    "bg": {
      "submitButton": "Изпращане",
      "orderTrackingPlaceHolder": "Номер на поръчка",
      "productDetailsLink": "Вижте детайли",
      "collectionDetailsLink": "Вижте колекцията",
      "alwaysActive": "Онлайн",
      "textPlaceholder": "Въведете съобщение...",
      "typing": "пише",
      "disclaimer": "Продължавайки, разбирате и приемате нашите условия.",
      "addToCartText": "Добавяне в кошницата"
    },
    "sr": {
      "submitButton": "Пошаљи",
      "orderTrackingPlaceHolder": "Број поруџбине",
      "productDetailsLink": "Погледајте детаље",
      "collectionDetailsLink": "Погледајте колекцију",
      "alwaysActive": "Online",
      "textPlaceholder": "Унесите поруку...",
      "typing": "куца",
      "disclaimer": "Настављајући, разумете и прихватате наше услове.",
      "addToCartText": "Додај у кошницу"
    },
    "fi": {
      "submitButton": "Lähetä",
      "orderTrackingPlaceHolder": "Tilausnumero",
      "productDetailsLink": "Katso tiedot",
      "collectionDetailsLink": "Katso kokoelma",
      "alwaysActive": "Online",
      "textPlaceholder": "Kirjoita viesti...",
      "typing": "kirjoittaa",
      "disclaimer": "Jatkamalla hyväksyt ja ymmärrät ehdot.",
      "addToCartText": "Lisää ostoskoriin"
    },
    "sk": {
      "submitButton": "Odoslať",
      "orderTrackingPlaceHolder": "Číslo objednávky",
      "productDetailsLink": "Zobraziť podrobnosti",
      "collectionDetailsLink": "Zobraziť kolekciu",
      "alwaysActive": "Online",
      "textPlaceholder": "Napíšte správu...",
      "typing": "píše",
      "disclaimer": "Pokračovaním rozumiete a súhlasíte s našimi podmienkami.",
      "addToCartText": "Pridať do košíka"
    },
    "hr": {
      "submitButton": "Pošalji",
      "orderTrackingPlaceHolder": "Broj narudžbe",
      "productDetailsLink": "Pogledaj detalje",
      "collectionDetailsLink": "Pogledaj kolekciju",
      "alwaysActive": "Online",
      "textPlaceholder": "Upišite poruku...",
      "typing": "piše",
      "disclaimer": "Nastavljajući, razumijete i prihvaćate naše uvjete.",
      "addToCartText": "Dodaj u košaricu"
    },
    "lt": {
      "submitButton": "Siųsti",
      "orderTrackingPlaceHolder": "Užsakymo numeris",
      "productDetailsLink": "Peržiūrėti detales",
      "collectionDetailsLink": "Peržiūrėti kolekciją",
      "alwaysActive": "Prisijungęs",
      "textPlaceholder": "Rašykite žinutę...",
      "typing": "rašoma",
      "disclaimer": "Tęsdami suprantate ir sutinkate su mūsų sąlygomis.",
      "addToCartText": "Pridėti į krepšelį"
    },
    "sl": {
      "submitButton": "Pošlji",
      "orderTrackingPlaceHolder": "Številka naročila",
      "productDetailsLink": "Poglej podrobnosti",
      "collectionDetailsLink": "Poglej zbirko",
      "alwaysActive": "Na spletu",
      "textPlaceholder": "Vnesite sporočilo...",
      "typing": "piše",
      "disclaimer": "Nadaljujete, razumete in sprejemate naše pogoje.",
      "addToCartText": "Dodaj v košarico"
    },
    "lv": {
      "submitButton": "Sūtīt",
      "orderTrackingPlaceHolder": "Pasūtījuma numurs",
      "productDetailsLink": "Skatīt detaļas",
      "collectionDetailsLink": "Skatīt kolekciju",
      "alwaysActive": "Tiešsaistē",
      "textPlaceholder": "Ievadiet ziņojumu...",
      "typing": "raksta",
      "disclaimer": "Turpinot, jūs saprotat un piekrītat mūsu noteikumiem.",
      "addToCartText": "Pievienot grozam"
    },
    "et": {
      "submitButton": "Saada",
      "orderTrackingPlaceHolder": "Tellimuse number",
      "productDetailsLink": "Vaata detaile",
      "collectionDetailsLink": "Vaata kollektsiooni",
      "alwaysActive": "Võrgus",
      "textPlaceholder": "Sisestage sõnum...",
      "typing": "kirjutab",
      "disclaimer": "Jätkates mõistate ja nõustute meie tingimustega.",
      "addToCartText": "Lisa ostukorvi"
    },
    "mk": {
      "submitButton": "Испрати",
      "orderTrackingPlaceHolder": "Број на нарачка",
      "productDetailsLink": "Погледнете детали",
      "collectionDetailsLink": "Погледнете ја колекцијата",
      "alwaysActive": "Онлајн",
      "textPlaceholder": "Внесете порака...",
      "typing": "пишува",
      "disclaimer": "Со продолжување, разбирате и се согласувате со нашите услови.",
      "addToCartText": "Додади во кошницата"
    },
    "sq": {
      "submitButton": "Dërgo",
      "orderTrackingPlaceHolder": "Numri i porosisë",
      "productDetailsLink": "Shiko detajet",
      "collectionDetailsLink": "Shiko koleksionin",
      "alwaysActive": "Në linjë",
      "textPlaceholder": "Shkruaj një mesazh...",
      "typing": "duke shkruar",
      "disclaimer": "Duke vazhduar, ju kuptoni dhe pranoni kushtet tona.",
      "addToCartText": "Shto në shportë"
    },
    "mt": {
      "submitButton": "Ibgħat",
      "orderTrackingPlaceHolder": "Numru tal-ordni",
      "productDetailsLink": "Ara d-dettalji",
      "collectionDetailsLink": "Ara l-kollezzjoni",
      "alwaysActive": "Online",
      "textPlaceholder": "Ikteb messaġġ...",
      "typing": "qiegħed jikteb",
      "disclaimer": "Billi tkompli, tifhem u taqbel mat-termini tagħna.",
      "addToCartText": "Żid fl-ġdid"
    },
    "is": {
      "submitButton": "Senda",
      "orderTrackingPlaceHolder": "Pöntunarnúmer",
      "productDetailsLink": "Skoða upplýsingar",
      "collectionDetailsLink": "Skoða safn",
      "alwaysActive": "Á netinu",
      "textPlaceholder": "Skrifaðu skilaboð...",
      "typing": "skrifar",
      "disclaimer": "Með því að halda áfram samþykkir þú skilmálana okkar.",
      "addToCartText": "Bæta í körfu"
    },
    "bs": {
      "submitButton": "Pošalji",
      "orderTrackingPlaceHolder": "Broj narudžbe",
      "productDetailsLink": "Pogledaj detalje",
      "collectionDetailsLink": "Pogledaj kolekciju",
      "alwaysActive": "Online",
      "textPlaceholder": "Upišite poruku...",
      "typing": "piše",
      "disclaimer": "Nastavljajući, razumijete i prihvatate naše uslove.",
      "addToCartText": "Dodaj u košaricu"
    }
  }
  